<template>
<div class="chapter">
<div class="inner_page">
<p class="first"><a id="pii"></a> </p>
<p class="follow"><a id="piii"></a> </p>
<p class="center"><a id="piv"></a> The Harvard Common Press<br/>
535 Albany Street • Boston, Massachusetts 02118<br/>
<a href="http://www.harvardcommonpress.com" target="_blank">www.harvardcommonpress.com</a></p>
<p class="center">Copyright © 2003 by Bill Hufnagle</p>
<p class="center"><em>A Few Words About Words</em></p>
<p class="center">Many of the folks who contributed recipes and I have used words and names that are<br/>
the trademarks of the Harley-Davidson Motor Company and/or the Buell Company.<br/>
All possible efforts have been made to use these words in a descriptive manner. The<br/>
Harvard Common Press and I respect the trademarks of the Harley-Davidson Motor<br/>
Company and the Buell Company and are grateful for the permission to use them<br/>
within this book. Those trademarks are:</p>
<p class="center">Aluminator, Bad Boy, Badlander, Bazooka, Biker Blues, Buddy Seat, Diamond Back,<br/>
Disc Glide, Dyna Glide, Eagle Iron, Electra Glide Road King, Enthusiast, Evolution,<br/>
Fantail, Fat Boy, FXR, FXRG, HD, H-D, H.O.G., Hog, Harley, Harley Chrome,<br/>
Harley Owners Group, Harley Women, Harley-Davidson, Heritage Softail, Heritage<br/>
Springer, Howitzer, Hugger, Ladies of Harley, Low Rider, Motorclothes, Revolution,<br/>
Road Glide, Road King, Roadster, Screamin' Eagle, Softail, Sport Glide, Sportster,<br/>
Springer, Sturgis, Super Glide, The Legend Rolls On, Thunderstar, Tour Glide, Tour-<br/>
Pak, Ultra Classic, V-Rod, Wide Glide, Willie G., and the Harley-Davidson bar and<br/>
shield logo are trademarks of H-D Michigan, Inc. Blast, Buell, Cyclone, Dynamic<br/>
Digital, Firebolt, Fuel Injection, Lightning, and Thunderbolt are trademarks of Buell.</p>
<p class="center">All rights reserved. No part of this publication may be reproduced or transmitted in<br/>
any form or by any means, electronic or mechanical, including photocopying, record-<br/>
ing, or any information storage or retrieval system, without permission in writing<br/>
from the publisher.</p>
<p class="center">Printed in the United States of America<br/>
Printed on acid-free paper</p>
<p class="center"><em>Library of Congress Cataloging-in-Publication Data</em></p>
<p class="center">Hufnagle, Bill.</p>
<p class="center">Biker Billy's hog wild on a Harley cookbook : 200 fiercely flavorful recipes to<br/>
kick-start your home cooking from Harley riders across the USA / Bill Hufnagle.<br/>
p. cm.<br/>
ISBN 1-55832-250-7 ((hc) : alk. paper)<br/>
1. Cookery. I. Title.<br/>
TX714.H82 2003<br/>
641.5—dc21 2002154184</p>
<p class="center">ISBN 13: 978-1-55832-250-9<br/>
ISBN 10: 1-55832-250-7</p>
<p class="center">Special bulk-order discounts are available on this and other Harvard Common Press<br/>
books. Companies and organizations may purchase books for premiums or resale, or<br/>
may arrange a custom edition, by contacting the Marketing Director at the address<br/>
above.</p>
<p class="center">10 9 8 7 6 5 4</p>
<p class="center"><em>For interior photo credits see <span href="#/back03#p312" title="Link target outside of Sample">[&gt;]</span>.</em><br/>
<em>Cover design by Night &amp; Day Design</em><br/>
<em>Book design by Richard Oriolo</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front01.vue?c55c3c94